module.exports = __webpack_public_path__ + "img/banner8202.76e949d1.png";